import React from "react";
import { Card, CardHeader, CardContent, Grid } from "@mui/material";
import {
  ClusterImageStats,
  ClusterImageUploadDataGrid,
} from "../components/labClusterSimulations";

const LabClusterSimulations = () => {
  return (
    <div className="fragmentContainer">
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <ClusterImageStats />
        <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }} >
          <Card variant="outlined">
            <CardHeader title="Available Lab Clusters"></CardHeader>
            <CardContent sx={{ padding: 0 }}>
              <ClusterImageUploadDataGrid />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default LabClusterSimulations;
